import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import { memo } from 'react'
import styled, { useTheme } from 'styled-components'

import { SVG_ICON_SIZE_CSS_VAR, StyledSvgIcon } from 'LuxKit/SvgIcon'
import { setCSSVar } from 'lib/theme/themeUtils'

export const CIRCULAR_PIN_SIZE = 24

const StyledSvg = styled.svg`
  pointer-events: none;
  color: ${(props) => props.theme.palette.brand.primary.normal};
  overflow: visible;

  & > path {
    pointer-events: all;
    cursor: pointer;
  }

  &.isActive {
    color: ${(props) => props.theme.palette.highlight.secondary.normalForeground};
  }
`

const IconContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  > ${StyledSvgIcon} {
    ${setCSSVar(SVG_ICON_SIZE_CSS_VAR, '100%')}
  }
`

const Container = styled.div`
  position: relative;
  width: auto;
  height: auto;
`

interface Props {
  isActive?: boolean
  pinColour?: string
}

function CircularPin({ isActive, children, pinColour }: PropsWithChildren<Props>) {
  const theme = useTheme()

  return (
    <Container>
      <StyledSvg
        className={clsx({ isActive })}
        height={CIRCULAR_PIN_SIZE}
        width={CIRCULAR_PIN_SIZE}
        viewBox="0 0 24 24"
      >
        <path
          d="M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z"
          fill={pinColour || 'currentColor'}
          stroke={theme.palette.neutral.default.eight}
        />
      </StyledSvg>

      <IconContainer>{children}</IconContainer>
    </Container>
  )
}

export default memo(CircularPin)
